import { RootState } from '../Store';
export const selectHeader = (state: RootState) => state.Header;